/**
 * @generated SignedSource<<b1111af1b95c1c948023120270998519>>
 * @relayHash b3e3f4fdf2cc861ef0e1ab36431b6456
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/581.0.0-2026-10-15T15:26:55.034Z/popularSearchesSitemapRootQuery

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type popularSearchesSitemapRootQuery$variables = {
  page: number;
  uriRef: string;
};
export type popularSearchesSitemapRootQuery$data = {
  readonly viewer: {
    readonly popularSearchesSitemap: {
      readonly categoryName: string | null;
      readonly popularBuyPages: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly path: string | null;
          };
        } | null> | null;
      } | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"PopularSearchesSitemapLayout_viewer">;
  };
};
export type popularSearchesSitemapRootQuery = {
  response: popularSearchesSitemapRootQuery$data;
  variables: popularSearchesSitemapRootQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "page"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "uriRef"
},
v2 = [
  {
    "kind": "Variable",
    "name": "uriRef",
    "variableName": "uriRef"
  }
],
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "categoryName",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": [
    {
      "kind": "Literal",
      "name": "first",
      "value": 1
    }
  ],
  "concreteType": "PopularBuyPagesConnection",
  "kind": "LinkedField",
  "name": "popularBuyPages",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PopularBuyPagesEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "LinkData",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v4/*:: as any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": "popularBuyPages(first:1)"
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "text",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isLinkable",
  "storageKey": null
},
v9 = [
  (v7/*:: as any*/),
  (v4/*:: as any*/),
  (v8/*:: as any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "concreteType": "PopularBuyPagesEdge",
  "kind": "LinkedField",
  "name": "edges",
  "plural": true,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "LinkData",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": (v9/*:: as any*/),
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*:: as any*/),
      (v1/*:: as any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "popularSearchesSitemapRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "PopularSearchesSitemapType",
            "kind": "LinkedField",
            "name": "popularSearchesSitemap",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v5/*:: as any*/)
            ],
            "storageKey": null
          },
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "PopularSearchesSitemapLayout_viewer"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*:: as any*/),
      (v0/*:: as any*/)
    ],
    "kind": "Operation",
    "name": "popularSearchesSitemapRootQuery",
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Viewer",
        "kind": "LinkedField",
        "name": "viewer",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": (v2/*:: as any*/),
            "concreteType": "PopularSearchesSitemapType",
            "kind": "LinkedField",
            "name": "popularSearchesSitemap",
            "plural": false,
            "selections": [
              (v3/*:: as any*/),
              (v5/*:: as any*/),
              (v6/*:: as any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "breadcrumbs",
                "plural": true,
                "selections": [
                  (v4/*:: as any*/),
                  (v7/*:: as any*/),
                  (v8/*:: as any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "mostPopularBuyPages",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 40
                  }
                ],
                "concreteType": "PopularBuyPagesConnection",
                "kind": "LinkedField",
                "name": "popularBuyPages",
                "plural": false,
                "selections": [
                  (v10/*:: as any*/)
                ],
                "storageKey": "popularBuyPages(first:40)"
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "LinkData",
                "kind": "LinkedField",
                "name": "descendantCategories",
                "plural": true,
                "selections": (v9/*:: as any*/),
                "storageKey": null
              },
              {
                "alias": "otherPopularBuyPages",
                "args": [
                  {
                    "kind": "Literal",
                    "name": "first",
                    "value": 200
                  },
                  {
                    "kind": "Variable",
                    "name": "page",
                    "variableName": "page"
                  },
                  {
                    "kind": "Literal",
                    "name": "pageStartOffset",
                    "value": 40
                  }
                ],
                "concreteType": "PopularBuyPagesConnection",
                "kind": "LinkedField",
                "name": "popularBuyPages",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "numberOfPages",
                    "storageKey": null
                  },
                  (v10/*:: as any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v6/*:: as any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "app-buyer-misc/581.0.0-2026-10-15T15:26:55.034Z/popularSearchesSitemapRootQuery",
    "metadata": {},
    "name": "popularSearchesSitemapRootQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "bb8a714a09a8c7fde4127812c6b8ff03";

export default node;
